module.exports = __webpack_public_path__ + "img/eraser3.4cca62a4.webp";